
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters({
      message: "getMessage",
    }),
    show: {
      get: function() {
        return this.$store.getters.showToast;
      },
      set: function(newValue) {
        this.$store.commit("openToast", false);
      },
    },
  },
  methods: {
    ...mapMutations(["openToast"]),
  },
};
